import Joi from 'joi';

/**
 * Schema for released billable event validation.
 */
export const releaseBillableEventsSchema = () =>
	Joi.object({})
		// Ignore extra fields
		.unknown();
